import { createReducer } from '@reduxjs/toolkit'
import { ordersActions } from './actions'
import { initialState } from './initialState'

/**
 * Reducer do módulo Orders
 */
export const ordersReducer = createReducer(initialState, (builder) => {
  builder
    // Fetch orders
    .addCase(ordersActions.fetchOrdersRequest, (state, action) => {
      state.listLoading = true
      state.listError = null
      if (action.payload) {
        state.filters = { ...state.filters, ...action.payload }
      }
    })
    .addCase(ordersActions.fetchOrdersSuccess, (state, action) => {
      state.listLoading = false
      state.orders = action.payload.orders
      state.pagination = action.payload.pagination
    })
    .addCase(ordersActions.fetchOrdersFailure, (state, action) => {
      state.listLoading = false
      state.listError = action.payload.error
    })
    
    // Update filters
    .addCase(ordersActions.updateFilters, (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
    })
    
    // Fetch order
    .addCase(ordersActions.fetchOrderRequest, (state, action) => {
      state.orderLoading = true
      state.orderError = null
      state.currentOrderId = action.payload
    })
    .addCase(ordersActions.fetchOrderSuccess, (state, action) => {
      state.orderLoading = false
      state.orderCache[action.payload.order.id] = action.payload.order
      state.currentOrderId = action.payload.order.id
    })
    .addCase(ordersActions.fetchOrderFailure, (state, action) => {
      state.orderLoading = false
      state.orderError = action.payload.error
    })
    
    // Cancel order
    .addCase(ordersActions.cancelOrderRequest, (state) => {
      state.orderLoading = true
      state.orderError = null
    })
    .addCase(ordersActions.cancelOrderSuccess, (state, action) => {
      state.orderLoading = false
      // Atualizar pedido no cache
      state.orderCache[action.payload.order.id] = action.payload.order
      // Atualizar na listagem também
      const index = state.orders.findIndex(o => o.id === action.payload.order.id)
      if (index >= 0) {
        state.orders[index] = action.payload.order
      }
    })
    .addCase(ordersActions.cancelOrderFailure, (state, action) => {
      state.orderLoading = false
      state.orderError = action.payload.error
    })
    
    // Clear order cache
    .addCase(ordersActions.clearOrderCache, (state) => {
      state.orderCache = {}
      state.currentOrderId = null
    })
    
    // Clear errors
    .addCase(ordersActions.clearListError, (state) => {
      state.listError = null
    })
    .addCase(ordersActions.clearOrderError, (state) => {
      state.orderError = null
    })
})

